import { render, staticRenderFns } from "./CreditoDebito.vue?vue&type=template&id=cb163968&"
import script from "./CreditoDebito.vue?vue&type=script&lang=js&"
export * from "./CreditoDebito.vue?vue&type=script&lang=js&"
import style0 from "./CreditoDebito.vue?vue&type=style&index=0&id=cb163968&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports